import React, { useState } from 'react'

import SoMany from 'images/inline/modal/so-many-points.svg'

import './BreakGateModals.scss'

const BreakLimitModal = ({ closeModal }) => {
  return (
    <div className={`modal-container-top modal-break-limit`}>
      <button
        className="modal-close"
        onClick={closeModal}
        aria-label="Next"
      ></button>
      <div className={`modal-image-header`}>
        <SoMany className={`header-image`} />
      </div>
      <div className={`modal-content-zone`}>
        <h1>Woah, you&apos;re crushing it!</h1>
        <p>
          Unfortunately, you&apos;ve maxed out on points for today. You can
          always keep reading and playing, and don&apos;t worry, tomorrow is
          another day to earn points.
        </p>
      </div>
    </div>
  )
}

export default BreakLimitModal
